// The backend holds every run whose YouTube budget is below the estimate for
// the enabled niches; the page warns with the same rule.
export function isBudgetBelowEstimate(budget: number, estimated: number): boolean {
  if (!(estimated > 0)) return false;
  return !(budget >= estimated);
}
